import { columnSettings } from "./report-template-setting";
import { format } from "date-fns";

const settings = {};
for (let columnSetting of columnSettings) {
  settings[columnSetting.field] = columnSetting;
}

const ReportTemplateDetail = (props) => {
  const {
    mykey,
    no,
    service_nama,
    speedo_akhir,
    km_warning,
    next,
    selisih,
    tanggal_terakhir_service,
    last,
  } = props;

  let newSelisih = selisih;

  const kmWarningAll = km_warning + last;
  let isWarning = speedo_akhir >= kmWarningAll && speedo_akhir < next;
  let isDanger = speedo_akhir >= next;

  if (next <= 0) {
    isWarning = false;
    isDanger = false;
    newSelisih = 0;
  }

  const selisihClass = isWarning
    ? "bg-yellow-100 text-yellow-600"
    : isDanger
    ? "bg-red-100 text-red-600"
    : "";

  return (
    <tr
      key={mykey}
      className="row-start-start w-full text-sm text-slate-700 !items-stretch"
    >
      <td
        className={`${settings["no"].layout} ${settings["no"].width} border-zinc-300 border border-t-0  px-2 pt-2 pb-1 `}
      >
        {no}
      </td>

      <td
        className={`${settings["service_nama"].layout} ${settings["service_nama"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {service_nama}
      </td>

      <td
        className={`${settings["speedo_akhir"].layout} ${settings["speedo_akhir"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {speedo_akhir ? speedo_akhir.toLocaleString("id-ID") : "-"}
      </td>

      <td
        className={`${settings["next"].layout} ${settings["next"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {next ? next.toLocaleString("id-ID") : "-"}
      </td>

      <td
        className={`${settings["selisih"].layout} ${settings["selisih"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 ${selisihClass}`}
      >
        {newSelisih ? newSelisih.toLocaleString("id-ID") : "-"}
      </td>

      <td
        className={`${settings["tanggal_terakhir_service"].layout} ${settings["tanggal_terakhir_service"].width} border-zinc-300 border border-t-0 border-l-0 px-2 pt-2 pb-1 `}
      >
        {tanggal_terakhir_service
          ? format(
              new Date(tanggal_terakhir_service),
              settings["tanggal_terakhir_service"].format
            )
          : "-"}
      </td>
    </tr>
  );
};

export default ReportTemplateDetail;
